import invariant from 'invariant';
import graphql from 'api/graphql';
import { fetchGigyaJWTPromise } from 'api/gigya';

import { GIGYA_BRAND_IMAGE_FAVORITES } from 'globalConst/gigya-const';

import * as analytics from 'analytics';
import { navigateToLoginScreen } from 'actions/gigya-router-actions';
import { showNotification } from 'actions/notifications-actions';
import { NotificationTypes, NotificationTexts } from '../components/Notifications/Notification';
import { favoriteActions, favoriteStationActions } from './actions-const';
import logger from 'util/logger';

function favoriteStation(station) {
  return async (dispatch, getState) => {
    const {
      favorites,
      user: { isLoggedIn },
    } = getState();

    const dispatchType = isLoggedIn
      ? favoriteStationActions.FAVORITE_STATION
      : favoriteStationActions.QUEUE_FAVORITE_STATION;
    // optimistic UI
    dispatch({
      type: dispatchType,
      payload: {
        id: station.id,
        stationSlug: station.slug,
        slug: station.slug,
        stationId: station.id,
        contentTypeId: 'station',
        updatedAt: Date.now(),
      },
    });
    if (isLoggedIn) {
      try {
        const jwtToken = await fetchGigyaJWTPromise();
        await graphql.mutateFavorite(jwtToken, station.id, 'station', true);

        dispatch(
          showNotification({
            message: NotificationTexts.STATION_ADD_TO_COLLECTION,
          })
        );

        analytics.trackFavoriteStation(station);
      } catch (e) {
        // rollback

        dispatch({
          type: favoriteActions.ROLLBACK_FAVORITES,
          payload: favorites,
        });

        dispatch(
          showNotification({
            message: NotificationTexts.STATION_ADD_TO_COLLECTION_ERROR,
            type: NotificationTypes.ERROR,
          })
        );
        logger.error(e);
      }
    }
  };
}

function unfavoriteStation(station) {
  return async (dispatch, getState) => {
    const { favorites } = getState();
    // optimistic UI
    dispatch({
      type: favoriteStationActions.UNFAVORITE_STATION,
      payload: station.slug,
    });
    try {
      const jwtToken = await fetchGigyaJWTPromise();
      await graphql.mutateFavorite(jwtToken, station.id, 'station', false);

      dispatch(
        showNotification({
          message: NotificationTexts.STATION_REMOVE_FROM_COLLECTION,
        })
      );

      analytics.trackUnfavoriteStation(station);
    } catch (e) {
      // rollback
      dispatch({
        type: favoriteActions.ROLLBACK_FAVORITES,
        payload: favorites,
      });

      dispatch(
        showNotification({
          message: NotificationTexts.STATION_REMOVE_FROM_COLLECTION_ERROR,
          type: NotificationTypes.ERROR,
        })
      );
      logger.error(e);
    }
  };
}

export function favoriteStationToggle(station) {
  return async (dispatch, getState) => {
    const {
      favorites: { stations: currentFavoriteStations },
      user: { isLoggedIn, signature },
    } = getState();

    if (!isLoggedIn) {
      analytics.gigyaExpand('add-my-category');
      navigateToLoginScreen(GIGYA_BRAND_IMAGE_FAVORITES);
    } else {
      invariant(signature, 'No signature found.');
    }

    const isFavorite = currentFavoriteStations.some(
      (favorite) => favorite.stationSlug === station.slug || favorite.slug === station.slug
    );

    if (isFavorite) {
      dispatch(unfavoriteStation(station));
    } else {
      dispatch(favoriteStation(station));
    }
  };
}

export function loadQueuedFavoriteStations() {
  return async (dispatch, getState) => {
    const {
      favorites,
      user: { isLoggedIn },
    } = getState();

    if (!isLoggedIn) {
      return;
    }

    const queuedStations = favorites.queue.stations;

    await Promise.all(
      queuedStations.map(async (station) => {
        try {
          const jwtToken = await fetchGigyaJWTPromise();
          await graphql.mutateFavorite(jwtToken, station.id, 'station', true);

          dispatch({
            type: favoriteStationActions.FAVORITE_STATION,
            payload: station,
          });

          dispatch(
            showNotification({
              message: NotificationTexts.STATION_ADD_TO_COLLECTION,
            })
          );
        } catch (e) {
          // rollback
          dispatch({
            type: favoriteActions.ROLLBACK_FAVORITES,
            payload: favorites,
          });

          dispatch(
            showNotification({
              message: NotificationTexts.STATION_ADD_TO_COLLECTION_ERROR,
              type: NotificationTypes.ERROR,
            })
          );
          logger.error(e);
        }
      })
    );
  };
}
